<div class="layer__header">
  <div class="layer__header__title">{{today}}</div>
  <a href="#" class="layer__header__btn-x" onclick="$(this).parents('.how-layer').hide(); return false;"></a>
</div>
<div class="layer__contents">
  <p>
    <strong>{{nickname}}</strong>님의 금일 받으신 하우'PC방 혜택입니다.</p>
  <table class="layer__contents__table">
    <thead>
      <tr>
        <th>구분</th>
        <th>내용</th>
      </tr>
    </thead>
    <tbody>
      {{#if isNoData }}
      <tr>
        <td colspan="2" class="no-data">금일 받으신 하우'PC방 혜택이 없습니다.</td>
      </tr>
      {{/if}}

      {{#if isPchipReceived}}
      <tr>
        <td>쿠폰혜택</td>
        <td>[하우’ PC방 쿠폰] 포커칩 30만칩 지급</td>
      </tr>
      {{/if}}

      {{#if isMoneyReceived}}
      <tr>
        <td>쿠폰혜택</td>
        <td>[하우’ PC방 쿠폰] 포커 3천억 골드 지급</td>
      </tr>
      {{/if}}

      {{#if isKicoutItemReceived}}
      <tr>
        <td>아이템혜택</td>
        <td>[아이템] 강퇴 아이템 지급</td>
      </tr>
      {{/if}}

    </tbody>
  </table>
  <p class="layer__contents__notice">※ PC방 혜택 내역은 “당일” 기준으로만 제공해드립니다.</p>
</div>